export default "__VITE_ASSET__7161d97a__"